<template>
  <div class="ecm__register">
    <div class="ecm__register-card">
      <h1 class="ecm__register-card--logo logo--title">BukuBook</h1>
      <el-form
        class="ecm__register-card__content-form"
        :model="registerForm"
        :rules="rules"
        ref="ruleForm"
        @submit.prevent.native="handleForm('ruleForm')"
      >
        <Input
          :label="'Fullname'"
          :field="'full_name'"
          v-model="registerForm.full_name"
        />
        <Input
          :label="'Email'"
          :field="'email'"
          v-model="registerForm.email"
        />
        <Input
          :label="'Password'"
          :field="'password'"
          :inputType="'password'"
          v-model="registerForm.password"
        />
        <div v-if="errorMessage" :class="[errorMessage ? 'ecm__register-card__content-form-error active' : 'ecm__register-card__content-form-error']">
          <p>{{ errorMessage }}</p>
        </div>
        <button class="ecm__register-card__content-form__btn-submit" native-type="submit">Submit</button>
        <!-- <button class="ecm__register-card__content-form__btn-google" native-type="submit">
          <i class="fab fa-google-plus-g"></i>
        </button> -->
      </el-form>
      <div class="ecm__register-card__bottom">
        <span>Already have an account ?</span>
        <button @click="$router.push('/login')">Sign in</button>
      </div>
    </div>
  </div>
</template>

<script>

import Input from '@/components/inputs/Input.vue'
import { instance as Axios } from '@/config/axiosInstance.js'
export default {
  name: 'Register',
  components: {
    Input
  },
  data () {
    return {
      errorMessage: '',
      registerForm: {
        full_name: '',
        email: '',
        password: ''
      },
      rules: {
        full_name: [
          { required: true, message: 'Please input your fullname', trigger: 'blur' },
          { min: 5, message: 'Minimum character length is 5 characters', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Please input your email', trigger: 'blur' },
          { type: 'email', message: 'email must be email format', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please input your password', trigger: 'blur' },
          { min: 5, message: 'Minimum character length is 5 characters', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Axios({
            method: 'post',
            url: 'user_register',
            data: {
              full_name: this.$data.registerForm.full_name,
              email: this.$data.registerForm.email,
              password: this.$data.registerForm.password
            }
          })
            .then(res => {
              this.$data.errorMessage = ''
              this.$router.push('/login')
            })
            .catch(err => {
              this.$data.errorMessage = err.response.data.msg
              setTimeout(() => {
                this.$data.errorMessage = ''
              }, 5000)
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__register {
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(315deg, rgba(12,7,82,0.804359243697479) 0%, rgba(66,125,240,0.14889705882352944) 100%),
            url("https://images.unsplash.com/photo-1551029506-0807df4e2031?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1034&q=80");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100vh;
  .ecm__register-card {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    background: white;
    width: 400px;
    padding: 35px 30px 60px;
    border-radius: 3px;
    .ecm__register-card--logo {
      text-align: center;
      font-weight: 600;
      font-size: 25px;
      margin-bottom: 20px;
    }
    .ecm__register-card__content-form {
      button {
        width: 100%;
        height: 35px;
        font-size: 14px;
        border: none;
        outline: none;
        cursor: pointer;
        border-radius: 5px;
        transition: .2s;
        color: white;
        font-weight: 500;
      }
      .ecm__register-card__content-form__btn-submit {
        margin-top: 10px;
        background: var(--color-blue-background);
        &:hover {
          background: var(--color-blue);
        }
      }
      .ecm__register-card__content-form__btn-google {
        margin-top: 10px;
        background: rgb(255, 47, 0);
        &:hover {
          background: rgb(255, 17, 0);
        }
      }
      .ecm__register-card__content-form-error {
        background: white;
        height: 30px;
        border-radius: 5px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px;
        color: white;
        width: 100%;
        &.active {
          background: rgb(255, 117, 117);
        }
      }
    }
    .ecm__register-card__bottom {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      margin-top: 8px;
      font-size: 15px;
      span {
        color: rgb(0, 0, 0);
        margin-right: 5px;
      }
      button {
        background: none;
        outline: none;
        border: none;
        cursor: pointer;
        font-weight: 500;
        letter-spacing: .5px;
        color: var(--color-blue-background);
        font-weight: 500;
      }
    }
  }
}
</style>
